module.exports = __webpack_public_path__ + "static/media/lu.2585715a.svg";